export enum AllotmentKind {
  perUnit = 0,
  perMember = 1,
}
